import React from 'react';
import SlideShow from "../../../components/slideshow/slideshow"

const Gallery = () => {
  return (<SlideShow slideShowDir={"/slideshow-home/content/markdown"} title={null}/>)

}

export default Gallery